import { createSlice } from "@reduxjs/toolkit";

const PlansReportSlice = createSlice({
  name: "plansReport",
  initialState: {
    value: [],
  },
  reducers: {
    UpdateValue(state, { payload }) {
      state.value = payload;
    },
    UpdateRow(state, { payload }) {
      state.value.forEach((item) => {
        if (item.id === payload.id) {
          Object.assign(item, payload);
        }
      });
    },
    DeleteRow(state, { payload }) {
      state.value = state.value.filter((item) => item.id !== payload.id);
    },
    CreateplansReport(state, { payload }) {
      state.value.unshift(payload);
    },
  },
});

export const selectAll = (state) => state.plansReport.value;
export const { DeleteRow, UpdateRow, CreateplansReport, UpdateValue } =
  PlansReportSlice.actions;
export default PlansReportSlice.reducer;
